import axios from "axios"
import { LocalStorage } from "./sharedPreferences/localStorage"
import { NO_HEADER_URL } from "@Constants/constant"
import Constants from "expo-constants"

axios.defaults.timeout = 60000 * 2 // Timeout in milliseconds (60000 ms = 60 seconds)

const { baseUrl, salutance, platform, testBaseURL } = Constants.expoConfig.extra
const SALUTANCE = salutance // false

const AXIOS_HEADERS = {
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        isApk: true
    }
}

const baseURL = () => {
    return baseUrl
}

const instance = axios.create({
    baseURL: baseUrl,
    ...AXIOS_HEADERS
})
const noAuthUrl = ["api/users/forgotPassword", "api/users/resetPassword"]

instance.interceptors.request.use(async (req) => {
    const access_token = await LocalStorage.getToken()
    const testUserEmail = await LocalStorage.getTestUser()
    const loginEmail = "userapple@toolbox.ovh"
    if (access_token) {
        req.headers["Authorization"] = `Bearer ${access_token}`

        if (noAuthUrl.includes(req?.url)) {
            delete req.headers["Authorization"]
        }

        req.headers["isApk"] = true
    }

    if (loginEmail === testUserEmail) {
        req.baseURL = `${testBaseURL}`
    } else {
        req.baseURL = `${baseUrl}`
    }
    //alert(req?.baseURL)
    return req
})

const REGISTRATION_BASE_URL = () => {
    return `${baseUrl}${NO_HEADER_URL.REGISTRATION}`
}

const RESEND_ACTIVATION_CODE_BASE_URL = () => {
    return `${baseUrl}${NO_HEADER_URL.RESEND_ACTIVATION_CODE}`
}

const ACTIVATE_ACCOUNT_BASE_URL = () => {
    return `${baseUrl}${NO_HEADER_URL.ACTIVATE_ACCOUNT}`
}

const FORGOT_PASSWORD_BASE_URL = () => {
    return `${baseUrl}${NO_HEADER_URL.FORGOT_PASSWORD}`
}

console.log(
    baseURL(),
    REGISTRATION_BASE_URL(),
    RESEND_ACTIVATION_CODE_BASE_URL(),
    ACTIVATE_ACCOUNT_BASE_URL(),
    FORGOT_PASSWORD_BASE_URL(),
    ",SALUTANCE : ",
    SALUTANCE,
    ",PLATFORM : ",
    platform
)

export {
    AXIOS_HEADERS,
    SALUTANCE,
    baseURL,
    REGISTRATION_BASE_URL,
    RESEND_ACTIVATION_CODE_BASE_URL,
    ACTIVATE_ACCOUNT_BASE_URL,
    FORGOT_PASSWORD_BASE_URL
}

export default instance
